import type { GridRowClassNameParams } from "@mui/x-data-grid";
import { SYSTEM_STEPPER_REVEAL_CLASS } from "@/ui/Inputs/SystemStepper";
import type { LocationGridLine } from "./locationGridRows";

/** A saved shift's line: it washes in the brand's tint on hover, as the design's shift rows do. */
export const SHIFT_ROW_CLASS = "locations-row--shift";

/**
 * A shift line's classes: its own, and the steppers' reveal scope, so pointing at or focusing anywhere in the row shows
 * the − and + of its Target and Required together, as the design's rows do.
 */
const SHIFT_ROW_CLASSES = `${SHIFT_ROW_CLASS} ${SYSTEM_STEPPER_REVEAL_CLASS}`;
/** An unsaved draft's line: washed in the brand's lightest tint, as the design's draft row is. */
export const DRAFT_ROW_CLASS = "locations-row--draft";
/** A band's trailing "Add shift" line: plain paper, closing the band. */
export const ADD_SHIFT_ROW_CLASS = "locations-row--add-shift";

/**
 * `dataGridProps.getRowClassName` for the Locations grid: a static class per kind of line, so its tint is a style rule
 * (`locationsGridSx`, `locationsGridPaintSx`) and the function never changes identity (a new one makes the grid re-read every row). The grid
 * answers its own band and detail rows before asking this.
 */
export const getLocationRowClassName = ({ row }: GridRowClassNameParams): string => {
	// The grid types `row` as its generic row; band and detail rows never reach a caller's classifier (SystemDataGrid).
	const line = row as LocationGridLine;
	switch (line.kind) {
		case "draft":
			return DRAFT_ROW_CLASS;
		case "addShift":
			return ADD_SHIFT_ROW_CLASS;
		case "shift":
			return SHIFT_ROW_CLASSES;
	}
};
